// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Reprocessos_UploadPhotoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /so/reprocessos/upload_photo.
 *
 * Returns the public URL of the uploaded reprocesso photo as the dados
 * primitive (legacy wire shape: `dados: '<url>'`).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Reprocessos_UploadPhotoResponseDados = string;

export type Reprocessos_UploadPhotoResponse = ApiResponse<Reprocessos_UploadPhotoResponseDados>;

registerResponseContract('Reprocessos_UploadPhotoResponse', {})
